import ufeApi from 'services/api/ufeApi';

function getPersonalizedPromotions(profileId, isUS) {
    const { isBeautyOffersEnabled, sdnUfeAPIUserKey, sdnDomainBaseUrl } = Sephora.configurationSettings;

    const showMLPromos = isBeautyOffersEnabled && isUS;

    const ML_URL = `${sdnDomainBaseUrl}/beauty-offers/v1/${profileId}`;
    const url = showMLPromos ? ML_URL : '/api/users/profiles/current/promotions?includeBCCData=true';

    const options = {
        method: 'GET',
        headers: showMLPromos
            ? {
                'X-Api-Key': sdnUfeAPIUserKey
            }
            : {}
    };
    const getPromosData = data => (showMLPromos ? data.data : data);

    return ufeApi.makeRequest(url, options).then(data => (data.errorCode ? Promise.reject(data) : getPromosData(data)));
}

export default { getPersonalizedPromotions };
